import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../components/Button';
import Card from '../components/Card';

const NotFound = () => {
	const { t } = useTranslation();

	return (
		<div className='container-game flex items-center justify-center min-h-screen'>
			<Card className='text-center py-12 px-8 max-w-md w-full'>
				<h1 className='text-5xl font-bold mb-4 text-primary-500'>{t('notFoundScreen.errorCode')}</h1>
				<h2 className='text-2xl font-bold mb-4'>{t('notFoundScreen.title')}</h2>
				<p className='mb-8 text-gray-600'>{t('notFoundScreen.message')}</p>
				<Link to='/'>
					<Button variant='primary'>{t('common.returnToHomeButton')}</Button>
				</Link>
			</Card>
		</div>
	);
};

export default NotFound;
